import { ISchedule } from '../../interfaces';
import { ValidateIf, ValidateNested } from 'class-validator';
import { IsValidSlot } from '../../validators';

export class ScheduleDTO implements ISchedule {
  @ValidateIf(({ monday }) => !!monday?.length)
  @IsValidSlot()
  monday: number[][];

  @ValidateIf(({ tuesday }) => !!tuesday?.length)
  @IsValidSlot()
  tuesday: number[][];

  @ValidateIf(({ wednesday }) => !!wednesday?.length)
  @IsValidSlot()
  wednesday: number[][];

  @ValidateIf(({ thursday }) => !!thursday?.length)
  @IsValidSlot()
  thursday: number[][];

  @ValidateIf(({ friday }) => !!friday?.length)
  @IsValidSlot()
  friday: number[][];

  @ValidateIf(({ saturday }) => !!saturday?.length)
  @IsValidSlot()
  saturday: number[][];

  @ValidateIf(({ sunday }) => !!sunday?.length)
  @IsValidSlot()
  sunday: number[][];
}
